import React from "react";
import EditableElement from "./EditableElement";

const EditableImage = ({
  image,
  isActive,
  onSetActive,
  onUpdate,
  onRemove,
}) => {
  return (
    <EditableElement
      element={{
        id: image.id,
        type: "image",
        src: image.src,
        width: image.width,
        height: image.height,
        position: image.position,
        rotation: image.rotation,
        shape: image.shape,
      }}
      isActive={isActive}
      onSetActive={onSetActive}
      onUpdate={onUpdate}
      onRemove={onRemove}
    />
  );
};

export default EditableImage;
